import React from 'react';

const CustomModal = ({ show, onClose, title, children, onSave, saveButtonText, maxWidth = '56rem', maxHeight = '90vh' }) => {
  if (!show) return null;

  return (
    <div className='custom-modal-backdrop' onClick={onClose}>
      <div className='custom-modal' style={{ maxWidth, maxHeight }} onClick={(e) => e.stopPropagation()}>
        <div className='custom-modal-header p-0'>
          {title}
          {/* <button type='button' className='btn-close' onClick={onClose}></button> */}
        </div>

        <div className='custom-modal-body p-0'>{children}</div>

        {(onClose || onSave) && (
          <div className='custom-modal-footer gap-2'>
            <button className='chatbot-cancel-btn outfit-regular' onClick={onClose}>
              Close
            </button>
            {onSave && (
              <button className='chatbot-save-btn outfit-regular' onClick={onSave}>
                {saveButtonText || 'Save Changes'}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomModal;
